<svelte:options tag={null}/>
<script>
    //ToDo Move the monthly and yearly calendar view from this navigation class to calendar
    import { createEventDispatcher } from "svelte";
    import { get_current_component } from "svelte/internal";
    import eventDispatcher from '../../../EventDispatcher';

    const component = get_current_component();
    const dispatch = createEventDispatcher();
    export let month = new Date().getMonth();
    export let year = new Date().getFullYear();
    let midRangeYear;
    let initialYear = year;
    let startYear;
    let endYear;
    let view = 'date';

    $: {
      midRangeYear = year || new Date().getFullYear();
    }
  
    let monthsOfYear = [
    ['January', 'Jan'],
    ['February', 'Feb'],
    ['March', 'Mar'],
    ['April', 'Apr'],
    ['May', 'May'],
    ['June', 'Jun'],
    ['July', 'Jul'],
    ['August', 'Aug'],
    ['September', 'Sep'],
    ['October', 'Oct'],
    ['November', 'Nov'],
    ['December', 'Dec']
  ];
    let yearsInCalendar = yearRange(midRangeYear);
    let monthSelectorOpen = false;
    let yearSelectorOpen = false;
    let topLabel = 'monthAndYear' || 'year' || 'yearRange';
    let availableMonths;
    let availableYears;

    $: {
      yearsInCalendar = yearRange(midRangeYear);
    }
    
    function yearRange(midRangeYear) {
      let years = [];
      let year = startYear = midRangeYear - 4;
      endYear = midRangeYear + 4;
      let index = 1;
      while ( index <= 9 ) {
          years.push([year++, index]);
          index++;
      }
      index = 0;
      return years;
    }
    

    $: {
      availableMonths = availableMonths || monthsOfYear.map((m) => {
        return Object.assign({}, {
          name: m[0],
          abbrev: m[1]
        });
      }) ;
    }
    
    $: {
      availableYears = yearsInCalendar ? yearsInCalendar.map((y) => {
        return Object.assign({}, {
          name: y[0],
          abbrev: y[1]
        });
      }) : availableYears;
    }
    
    function toggleMonthSelectorOpen() {
      if(topLabel === 'monthAndYear') {
        topLabel = 'year'
        view = 'month';
        dispatch("viewChange", 'month');
        eventDispatcher.dispatchCustomEvent(component, new Event('viewChange'), 'viewChange', 'month');
      } else {
        topLabel = 'monthAndYear'
        view = 'date';
        dispatch("viewChange", 'date');
        eventDispatcher.dispatchCustomEvent(component, new Event('viewChange'), 'viewChange', 'date');
      }
      monthSelectorOpen = !monthSelectorOpen;
    }

    function monthSelected(event, { i }) {
      event.stopPropagation();
      month=i;
      dispatch("monthSelected", i);
      eventDispatcher.dispatchCustomEvent(component, new Event('monthSelected'), 'monthSelected', i);
      toggleMonthSelectorOpen();
    }

    function toggleYearSelectorOpen() {
      if(topLabel === 'year') {
        topLabel = 'yearRange';
        view = 'year';
        dispatch("viewChange", 'year');
        eventDispatcher.dispatchCustomEvent(component, new Event('viewChange'), 'viewChange', 'year');
      } else {
        topLabel = 'year';
        view = 'month';
        dispatch("viewChange", 'month');
        eventDispatcher.dispatchCustomEvent(component, new Event('viewChange'), 'viewChange', 'month');
      }
      yearSelectorOpen = !yearSelectorOpen;
    }
    function yearSelected(event, { y }) {
      year = y;
      event.stopPropagation();
      dispatch("yearSelected", y.name);
      eventDispatcher.dispatchCustomEvent(component, new Event('yearSelected'), 'yearSelected', y.name);
      toggleYearSelectorOpen();
    }

    const next = () => {
      switch(view) {
        case 'date' : nextMonth(); break;
        case 'month' : nextYear(); break;
        case 'year' : nextYearRange(); break;
        default : nextMonth();
      }
    };
  
    const prev = () => {
      switch(view) {
        case 'date' : prevMonth(); break;
        case 'month' : prevYear(); break;
        case 'year' : prevYerRange(); break;
        default : prevMonth();
      }
    };

    const nextMonth = () => {
      if (month === 11) {
        month = 0;
        year = year + 1;
        dispatch("monthSelected", month);
        dispatch("yearSelected", year);
        eventDispatcher.dispatchCustomEvent(component, new Event('monthSelected'), 'monthSelected', month);
        eventDispatcher.dispatchCustomEvent(component, new Event('yearSelected'), 'yearSelected', year);
        return;
      }
      month = month + 1;
      dispatch("monthSelected", month);
      eventDispatcher.dispatchCustomEvent(component, new Event('monthSelected'), 'monthSelected', month);
    };
  
    const prevMonth = () => {
      if (month === 0) {
        month = 11;
        year -= 1;
        dispatch("monthSelected", month);
        dispatch("yearSelected", year);
        eventDispatcher.dispatchCustomEvent(component, new Event('monthSelected'), 'monthSelected', month);
        eventDispatcher.dispatchCustomEvent(component, new Event('yearSelected'), 'yearSelected', year);
        return;
      }
      month -= 1;
      dispatch("monthSelected", month);
      eventDispatcher.dispatchCustomEvent(component, new Event('monthSelected'), 'monthSelected', month);
    };

    const nextYear = () => {
      year++;
      dispatch("yearSelected", year);
      eventDispatcher.dispatchCustomEvent(component, new Event('yearSelected'), 'yearSelected', year);
    };
  
    const prevYear = () => {
      year--;
      dispatch("yearSelected", year);
      eventDispatcher.dispatchCustomEvent(component, new Event('yearSelected'), 'yearSelected', year);
    };

    const nextYearRange = () => {
      midRangeYear += 9;
    };
  
    const prevYerRange = () => {
      midRangeYear -= 9;
    };
  </script>
    <div class='nav-container'>
      <i class="prev" data-testid="prevTest" on:click={prev}></i>

      <div class="heading-section">
      {#if topLabel === 'monthAndYear'}
        <div class="label" data-testid="monthAndYearTestLabel" on:click={toggleMonthSelectorOpen}>
          {monthsOfYear[month][0]} {year}
        </div> 
        {/if}
      {#if topLabel === 'year'}
        <div class="label" data-testid="yearTestLabel" on:click={toggleYearSelectorOpen}>
          {year}
        </div> 
      {/if}
      {#if topLabel === 'yearRange'}
        <div class="label" data-testid="yearRangeTestLabel" >
          {startYear} - {endYear}
        </div> 
      {/if}
      
      </div>

      <i class='next' data-testid="nextTest" on:click={next}></i>
    </div>
    <div class="selector" class:open={monthSelectorOpen}>
      {#each availableMonths as monthDefinition, index}
        <div 
          class="selector--month selector--monthOrYear" 
          class:selected={index === month && initialYear === year}
          on:click={e => monthSelected(e, { i: index })}
        >
          <span>{monthDefinition.abbrev}</span>
        </div>
      {/each}
    </div>

    <div class="selector" class:open={yearSelectorOpen}>
      {#each availableYears as yearDefinition, index}
        <div 
          class="selector--year selector--monthOrYear" 
          class:selected={yearDefinition.name === year}
          on:click={e => yearSelected(e, { y: yearDefinition })}
        >
          <span>{yearDefinition.name}</span>
        </div>
      {/each}
    </div>

  
  <style type="text/scss" lang="scss">
     @import '../../../global.scss';

     .nav-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 6px 0;
      width: 100%
     }

     .next {
      @include gg-play-button;
      cursor: pointer;
      
      &::before {
        position: absolute;
		    border-top: 10px solid transparent;
		    border-bottom: 10px solid transparent;
		    border-left: 15px solid;
		    top: 0;
		    left: 0;
	    }
    }

    .prev {
      @include arrow-prev;
      cursor: pointer;
      right:0;
    }

    .heading-section { 
      padding: 5px 0;
      color: $and-charcoal;
      font-family: "Poppins", sans-serif;
      @include fontSize(16px);
    }
    .label { 
      cursor: pointer;
      padding: 1px 0 0 15px;
    }
    .selector { 
      position: absolute;
      top: 55px; 
      left: 0; 
      right: 0; 
      bottom: 0; 
      background-color: #fff;
      font-family: "Poppins", sans-serif;
      @include fontSize(16px);
      visibility: hidden;
      z-index: 1;
      text-align: center;
    
    &.open { 
      visibility: visible;
      opacity: 1;
    }
    &--month { 
      font-weight: 600;
      width: 18%; 
      margin: 4% 2%; 
      height: 20%;
      display: inline-block;
      color: #4a4a4a;
      opacity: 1;
      &:hover {
        margin: 3% 1.5%; 
      }
    }
    &--year { 
      width: 21%; 
      margin: 3% 4%; 
      height: 22%;
      display: inline-block;
      color: #4a4a4a;
      opacity: 1;
      &:hover {
        margin: 2% 3.5%;
      }
    }
    &--monthOrYear:hover { 
      cursor: pointer;
      border-radius: 10px;
      border: 1px solid $and-blue;
    }
    &--monthOrYear.selected { 
      background:  $and-blue;
      border-radius: 10px;
      color: #fff;
    }
    &--monthOrYear:before { 
      content: ' ';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }
    &--monthOrYear span { 
      vertical-align: middle; 
      display: inline-block;
    }
  }
  </style>